import { createSelector } from 'reselect';

import getPickupTime from './getPickupTime';
import getDeliveryTime from './getDeliveryTime';
import getSaleType from './getSaleType';

import { DELIVERY_SALE_TYPES } from '../constants/saleType';
import { ASAP_TIME } from '../constants';

/**
 * This will only be used for Day Part Menu Availability revalidation
 */
export default createSelector(
  [getPickupTime, getDeliveryTime, getSaleType],
  (pickupTime, deliveryTime, saleType) => {
    return createOrderDateTime(saleType, deliveryTime, pickupTime);
  },
);

export function createOrderDateTime(
  saleType: SALE_TYPE,
  deliveryTime: string,
  pickupTime: string | undefined,
) {
  let returningTime;

  if (DELIVERY_SALE_TYPES.includes(saleType)) {
    returningTime = deliveryTime === ASAP_TIME ? undefined : deliveryTime;
  } else {
    returningTime = pickupTime;
  }

  return returningTime;
}
